
import allocationfiles from './allocationFiles'
import file from './Files'
import filetype from './filetype'


export default {
  allocationfiles,
  file,
  filetype
}


// WEBPACK FOOTER //
// ./src/transformers/Files/index.js